import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserService } from '../shared/services/user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private userService: UserService,
    private router: Router
  ) {}

  async canActivate() {
    const session = await this.userService.isValidSession();

    if (!session.data.session) {
      await this.router.navigate(['/']);
      return false;
    }
    return !session.error;
  }
}
